export enum MyProfileTab {
  MyAccount = "my-account",
  EnglishLevel = "english-level",
}
